export function resolveUserJurisdictionId(userData: unknown): number | undefined {
  if (!userData || typeof userData !== 'object') return undefined;

  const user = userData as Record<string, unknown>;
  const candidates = [
    user.jurisdictionId,
    user.jurisdiccion_id,
    typeof user.jurisdiccion === 'object' && user.jurisdiccion !== null
      ? (user.jurisdiccion as { id?: unknown }).id
      : user.jurisdiccion,
    typeof user.zone === 'object' && user.zone !== null
      ? (user.zone as { jurisdiccion?: unknown; jurisdictionId?: unknown }).jurisdictionId ??
        (user.zone as { jurisdiccion?: unknown }).jurisdiccion
      : undefined,
  ];

  for (const value of candidates) {
    const id = typeof value === 'string' ? Number(value) : typeof value === 'number' ? value : NaN;
    if (Number.isFinite(id) && id > 0) return id;
  }

  return undefined;
}
